/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  BodyVerifyWihTokenUsersActivatePost,
  BodyVerifyWihTokenUsersActivatePostFromJSON,
  BodyVerifyWihTokenUsersActivatePostToJSON,
  HTTPValidationError,
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  LoginResponse,
  LoginResponseFromJSON,
  LoginResponseToJSON,
  MinBalance,
  MinBalanceFromJSON,
  MinBalanceToJSON,
  MinBalanceResponse,
  MinBalanceResponseFromJSON,
  MinBalanceResponseToJSON,
  RecoverEmail,
  RecoverEmailFromJSON,
  RecoverEmailToJSON,
  RegisterResponse,
  RegisterResponseFromJSON,
  RegisterResponseToJSON,
  ResetPasswordResponse,
  ResetPasswordResponseFromJSON,
  ResetPasswordResponseToJSON,
  ResetPasswordWithToken,
  ResetPasswordWithTokenFromJSON,
  ResetPasswordWithTokenToJSON,
  UserCreate,
  UserCreateFromJSON,
  UserCreateToJSON,
  UserLogin,
  UserLoginFromJSON,
  UserLoginToJSON,
  UserUpdatePassword,
  UserUpdatePasswordFromJSON,
  UserUpdatePasswordToJSON,
} from '../models';

export interface ChangePasswordUsersPasswordPostRequest {
  userUpdatePassword: UserUpdatePassword;
  acceptLanguage?: string;
}

export interface CreateUserUsersRegisterPostRequest {
  userCreate: UserCreate;
  acceptLanguage?: string;
}

export interface GetUserDataUsersMeGetRequest {
  acceptLanguage?: string;
}

export interface LoginAccessTokenUsersLoginPostRequest {
  userLogin: UserLogin;
  acceptLanguage?: string;
}

export interface RecoverPasswordUsersPasswordRecoveryPostRequest {
  recoverEmail: RecoverEmail;
  acceptLanguage?: string;
}

export interface ResetPasswordUsersResetPasswordPostRequest {
  resetPasswordWithToken: ResetPasswordWithToken;
  acceptLanguage?: string;
}

export interface UpdateLowBalanceUsersMinBalancePostRequest {
  minBalance: MinBalance;
  acceptLanguage?: string;
}

export interface VerifyWihTokenUsersActivatePostRequest {
  bodyVerifyWihTokenUsersActivatePost: BodyVerifyWihTokenUsersActivatePost;
  acceptLanguage?: string;
}

/**
 *
 */
export class UsersApi extends runtime.BaseAPI {
  /**
   *    An endpoint is used to change the password of the user (it will be called after     /password-recovery and /reset-password endpoints) for the process of changing the password.    - An Exception Error will be raised if the user or old password is not authenticated.    - If the above step went smoothly the password will be changed.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **new_password**: it is required.    - **old_password**: it is required.
   * Change Password
   */
  async changePasswordUsersPasswordPostRaw(
    requestParameters: ChangePasswordUsersPasswordPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<any>> {
    if (
      requestParameters.userUpdatePassword === null ||
      requestParameters.userUpdatePassword === undefined
    ) {
      throw new runtime.RequiredError(
        'userUpdatePassword',
        'Required parameter requestParameters.userUpdatePassword was null or undefined when calling changePasswordUsersPasswordPost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/users/password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: UserUpdatePasswordToJSON(requestParameters.userUpdatePassword),
      },
      initOverrides
    );

    return new runtime.TextApiResponse(response) as any;
  }

  /**
   *    An endpoint is used to change the password of the user (it will be called after     /password-recovery and /reset-password endpoints) for the process of changing the password.    - An Exception Error will be raised if the user or old password is not authenticated.    - If the above step went smoothly the password will be changed.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **new_password**: it is required.    - **old_password**: it is required.
   * Change Password
   */
  async changePasswordUsersPasswordPost(
    requestParameters: ChangePasswordUsersPasswordPostRequest,
    initOverrides?: RequestInit
  ): Promise<any> {
    const response = await this.changePasswordUsersPasswordPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    An endpoint is used for the registration process.     * First it will:      - check the validation of the registered email because in    the users\' table in Channels DB, the email should be unique.    - check the validation of the registered phone number because    the value of the phone number should be unique in the users\' table in Channels DB.    if one of these values is existed an Exception Error will be raised.     - check if the registered user hasn\'t a channel id in order to create one for the user, in this step        - it will check from the validation of the registered channel name        because the channel name should be unique in Channels DB.       if the channel name is existed an Exception Error will be raised, else it will create a channel id.      - otherwise, if the registered user has a channel id      (mostly this happens if the user gets registered directly through    the endpoint by using swagger or another tool for APIs) it will check    whether the channel_id gets existed or not. if it doesn\'t exist an Exception Error will be raised.     * Second if all the above steps went smoothly, it will insert a new user to DB.     * Third sends the user data to the Balance Microservice endpoint in the core    to create a balance ms reference for the user. An Exception Error will be raised if the process gets failed.     * Fourth creates an activation token that will be sent with the activation email to the registered email.     * Finally, creates initial cards for the new user.      This endpoint has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **email**: it is required and must be unique.    - **balance_ms_reference**: don\'t add a value to this attribute, because it will be created later.    - **is_active**: it is  optional to change its value.    - **is_verified**: it is optional to change its value.    - **name**: it is required, and should be filled out.    - **phone**: it is required and must be unique.    - **channel_id**: prefer to not set it with any value, let the endpoint create it.    - **channel_name**: it is required and must be unique.    - **password**: it is required.
   * Create User
   */
  async createUserUsersRegisterPostRaw(
    requestParameters: CreateUserUsersRegisterPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<RegisterResponse>> {
    if (
      requestParameters.userCreate === null ||
      requestParameters.userCreate === undefined
    ) {
      throw new runtime.RequiredError(
        'userCreate',
        'Required parameter requestParameters.userCreate was null or undefined when calling createUserUsersRegisterPost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    const response = await this.request(
      {
        path: `/users/register`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: UserCreateToJSON(requestParameters.userCreate),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RegisterResponseFromJSON(jsonValue)
    );
  }

  /**
   *    An endpoint is used for the registration process.     * First it will:      - check the validation of the registered email because in    the users\' table in Channels DB, the email should be unique.    - check the validation of the registered phone number because    the value of the phone number should be unique in the users\' table in Channels DB.    if one of these values is existed an Exception Error will be raised.     - check if the registered user hasn\'t a channel id in order to create one for the user, in this step        - it will check from the validation of the registered channel name        because the channel name should be unique in Channels DB.       if the channel name is existed an Exception Error will be raised, else it will create a channel id.      - otherwise, if the registered user has a channel id      (mostly this happens if the user gets registered directly through    the endpoint by using swagger or another tool for APIs) it will check    whether the channel_id gets existed or not. if it doesn\'t exist an Exception Error will be raised.     * Second if all the above steps went smoothly, it will insert a new user to DB.     * Third sends the user data to the Balance Microservice endpoint in the core    to create a balance ms reference for the user. An Exception Error will be raised if the process gets failed.     * Fourth creates an activation token that will be sent with the activation email to the registered email.     * Finally, creates initial cards for the new user.      This endpoint has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **email**: it is required and must be unique.    - **balance_ms_reference**: don\'t add a value to this attribute, because it will be created later.    - **is_active**: it is  optional to change its value.    - **is_verified**: it is optional to change its value.    - **name**: it is required, and should be filled out.    - **phone**: it is required and must be unique.    - **channel_id**: prefer to not set it with any value, let the endpoint create it.    - **channel_name**: it is required and must be unique.    - **password**: it is required.
   * Create User
   */
  async createUserUsersRegisterPost(
    requestParameters: CreateUserUsersRegisterPostRequest,
    initOverrides?: RequestInit
  ): Promise<RegisterResponse> {
    const response = await this.createUserUsersRegisterPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    An endpoint is used to retrieve the data of a user.     It is used by Channels STORE frontend in the profile page,    - Updates the balance of the user to retrieve the newest balance with the other data.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).
   * Get User Data
   */
  async getUserDataUsersMeGetRaw(
    requestParameters: GetUserDataUsersMeGetRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<RegisterResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/users/me`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RegisterResponseFromJSON(jsonValue)
    );
  }

  /**
   *    An endpoint is used to retrieve the data of a user.     It is used by Channels STORE frontend in the profile page,    - Updates the balance of the user to retrieve the newest balance with the other data.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).
   * Get User Data
   */
  async getUserDataUsersMeGet(
    requestParameters: GetUserDataUsersMeGetRequest,
    initOverrides?: RequestInit
  ): Promise<RegisterResponse> {
    const response = await this.getUserDataUsersMeGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *   An endpoint is used for the login process.    - Checks from the authentication of the entered email and password,    if one of them is not authenticated an Exception Error will be raised.    - If the above step goes smoothly an access token will be created for the user.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **email**: it is required and must be the one that the user used in the registration process.    - **password**: it is required and must be the same password the user registered with.
   * Login Access Token
   */
  async loginAccessTokenUsersLoginPostRaw(
    requestParameters: LoginAccessTokenUsersLoginPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<LoginResponse>> {
    if (
      requestParameters.userLogin === null ||
      requestParameters.userLogin === undefined
    ) {
      throw new runtime.RequiredError(
        'userLogin',
        'Required parameter requestParameters.userLogin was null or undefined when calling loginAccessTokenUsersLoginPost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    const response = await this.request(
      {
        path: `/users/login`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: UserLoginToJSON(requestParameters.userLogin),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LoginResponseFromJSON(jsonValue)
    );
  }

  /**
   *   An endpoint is used for the login process.    - Checks from the authentication of the entered email and password,    if one of them is not authenticated an Exception Error will be raised.    - If the above step goes smoothly an access token will be created for the user.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **email**: it is required and must be the one that the user used in the registration process.    - **password**: it is required and must be the same password the user registered with.
   * Login Access Token
   */
  async loginAccessTokenUsersLoginPost(
    requestParameters: LoginAccessTokenUsersLoginPostRequest,
    initOverrides?: RequestInit
  ): Promise<LoginResponse> {
    const response = await this.loginAccessTokenUsersLoginPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    An endpoint is used for the password recovery process.    - Checks, if the sending email is related to an existed user, if not an Exception Error will be raised.    - If the above step goes smoothly a password token will be created for the user.    - An email with a recovery link will be sent to the user.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attribute:    - **email**: it is required and must be the one that the user used in the registration process.
   * Recover Password
   */
  async recoverPasswordUsersPasswordRecoveryPostRaw(
    requestParameters: RecoverPasswordUsersPasswordRecoveryPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<ResetPasswordResponse>> {
    if (
      requestParameters.recoverEmail === null ||
      requestParameters.recoverEmail === undefined
    ) {
      throw new runtime.RequiredError(
        'recoverEmail',
        'Required parameter requestParameters.recoverEmail was null or undefined when calling recoverPasswordUsersPasswordRecoveryPost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    const response = await this.request(
      {
        path: `/users/password-recovery`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RecoverEmailToJSON(requestParameters.recoverEmail),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResetPasswordResponseFromJSON(jsonValue)
    );
  }

  /**
   *    An endpoint is used for the password recovery process.    - Checks, if the sending email is related to an existed user, if not an Exception Error will be raised.    - If the above step goes smoothly a password token will be created for the user.    - An email with a recovery link will be sent to the user.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attribute:    - **email**: it is required and must be the one that the user used in the registration process.
   * Recover Password
   */
  async recoverPasswordUsersPasswordRecoveryPost(
    requestParameters: RecoverPasswordUsersPasswordRecoveryPostRequest,
    initOverrides?: RequestInit
  ): Promise<ResetPasswordResponse> {
    const response = await this.recoverPasswordUsersPasswordRecoveryPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    An endpoint is used for the password reset process (it will be called after     /password-recovery) for the process of changing the password.    - Checks if the sending token is verified, if not an Exception Error will be raised    - If the above step went smoothly the password will be changed to the new one.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **token**: it is required and it can be generated from the /password-recovery endpoint.    - **new_password**: it is required.
   * Reset Password
   */
  async resetPasswordUsersResetPasswordPostRaw(
    requestParameters: ResetPasswordUsersResetPasswordPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<ResetPasswordResponse>> {
    if (
      requestParameters.resetPasswordWithToken === null ||
      requestParameters.resetPasswordWithToken === undefined
    ) {
      throw new runtime.RequiredError(
        'resetPasswordWithToken',
        'Required parameter requestParameters.resetPasswordWithToken was null or undefined when calling resetPasswordUsersResetPasswordPost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    const response = await this.request(
      {
        path: `/users/reset-password`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ResetPasswordWithTokenToJSON(
          requestParameters.resetPasswordWithToken
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResetPasswordResponseFromJSON(jsonValue)
    );
  }

  /**
   *    An endpoint is used for the password reset process (it will be called after     /password-recovery) for the process of changing the password.    - Checks if the sending token is verified, if not an Exception Error will be raised    - If the above step went smoothly the password will be changed to the new one.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **token**: it is required and it can be generated from the /password-recovery endpoint.    - **new_password**: it is required.
   * Reset Password
   */
  async resetPasswordUsersResetPasswordPost(
    requestParameters: ResetPasswordUsersResetPasswordPostRequest,
    initOverrides?: RequestInit
  ): Promise<ResetPasswordResponse> {
    const response = await this.resetPasswordUsersResetPasswordPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    An endpoint is used to update the min balance value for a specific channel.    - Checks, if the channel is existed, if not an Exception Error, will be raised    - If the above step wnt smoothly the minimum balance value will be changed to the new one,    and the email accounts that will be used when send a reminder of reaching the min balance value.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **low_balance**: it is required, and it is type float.    - **channel_id**: it is required, and it is type int.    - **emails**: it is required, it is possible to set multiple email accounts.
   * Update Low Balance
   */
  async updateLowBalanceUsersMinBalancePostRaw(
    requestParameters: UpdateLowBalanceUsersMinBalancePostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<MinBalanceResponse>> {
    if (
      requestParameters.minBalance === null ||
      requestParameters.minBalance === undefined
    ) {
      throw new runtime.RequiredError(
        'minBalance',
        'Required parameter requestParameters.minBalance was null or undefined when calling updateLowBalanceUsersMinBalancePost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    const response = await this.request(
      {
        path: `/users/min-balance`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: MinBalanceToJSON(requestParameters.minBalance),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MinBalanceResponseFromJSON(jsonValue)
    );
  }

  /**
   *    An endpoint is used to update the min balance value for a specific channel.    - Checks, if the channel is existed, if not an Exception Error, will be raised    - If the above step wnt smoothly the minimum balance value will be changed to the new one,    and the email accounts that will be used when send a reminder of reaching the min balance value.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **low_balance**: it is required, and it is type float.    - **channel_id**: it is required, and it is type int.    - **emails**: it is required, it is possible to set multiple email accounts.
   * Update Low Balance
   */
  async updateLowBalanceUsersMinBalancePost(
    requestParameters: UpdateLowBalanceUsersMinBalancePostRequest,
    initOverrides?: RequestInit
  ): Promise<MinBalanceResponse> {
    const response = await this.updateLowBalanceUsersMinBalancePostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    An endpoint is used after a new account email is sent to activate the user account.    - Checks the validation of the email, an Error Exception will be raised if the email does not exist.    - Checks the existence of the user, an Error Exception will be raised if the user does not exist.    - Checks if the activation of the channel, an Error Exception will be raised if the channel is not active.     Otherwise, activates the channel and creates an access token for it.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **token**: API Key of the channel.
   * Verify Wih Token
   */
  async verifyWihTokenUsersActivatePostRaw(
    requestParameters: VerifyWihTokenUsersActivatePostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<LoginResponse>> {
    if (
      requestParameters.bodyVerifyWihTokenUsersActivatePost === null ||
      requestParameters.bodyVerifyWihTokenUsersActivatePost === undefined
    ) {
      throw new runtime.RequiredError(
        'bodyVerifyWihTokenUsersActivatePost',
        'Required parameter requestParameters.bodyVerifyWihTokenUsersActivatePost was null or undefined when calling verifyWihTokenUsersActivatePost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    const response = await this.request(
      {
        path: `/users/activate`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: BodyVerifyWihTokenUsersActivatePostToJSON(
          requestParameters.bodyVerifyWihTokenUsersActivatePost
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LoginResponseFromJSON(jsonValue)
    );
  }

  /**
   *    An endpoint is used after a new account email is sent to activate the user account.    - Checks the validation of the email, an Error Exception will be raised if the email does not exist.    - Checks the existence of the user, an Error Exception will be raised if the user does not exist.    - Checks if the activation of the channel, an Error Exception will be raised if the channel is not active.     Otherwise, activates the channel and creates an access token for it.     it has a header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).     and a body request contains the following attributes:    - **token**: API Key of the channel.
   * Verify Wih Token
   */
  async verifyWihTokenUsersActivatePost(
    requestParameters: VerifyWihTokenUsersActivatePostRequest,
    initOverrides?: RequestInit
  ): Promise<LoginResponse> {
    const response = await this.verifyWihTokenUsersActivatePostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
